import { ManifestComponentExtensionType } from '@wix/editor-platform-manifest-services';
import { ResolverByExtensionType } from '../types';

export const getElementsPanelPropsForUnknownType: ResolverByExtensionType<
  ManifestComponentExtensionType.UNKNOWN
> = () => ({ items: [] });
